const toFiniteNumber = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const resolveAgentServiceTicketCount = (row = {}) => {
  const explicitCount = row.ticketCount ?? row.completedTickets;
  if (explicitCount !== undefined && explicitCount !== null) {
    return toFiniteNumber(explicitCount);
  }

  const totalServiceTime = toFiniteNumber(row.sum);
  const averagePerTicket = toFiniteNumber(row.avgPerTicket ?? row.average);
  if (!totalServiceTime || !averagePerTicket) return 0;

  return Math.max(0, Math.round(totalServiceTime / averagePerTicket));
};

export const resolveAgentServiceServiceTicketCount = (service = {}) => {
  const explicitCount = service.completedTickets ?? service.ticketCount;
  if (explicitCount !== undefined && explicitCount !== null) {
    return toFiniteNumber(explicitCount);
  }

  return (service.agentsData || []).reduce(
    (total, agent) => total + resolveAgentServiceTicketCount(agent),
    0
  );
};

export const resolveAgentServiceBranchTicketCount = (branch = {}) => {
  const explicitCount = branch.completedTickets ?? branch.ticketCount;
  if (explicitCount !== undefined && explicitCount !== null) {
    return toFiniteNumber(explicitCount);
  }

  return (branch.servicesData || []).reduce(
    (total, service) => total + resolveAgentServiceServiceTicketCount(service),
    0
  );
};
